import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const links = [
  { to: '/',          label: 'Check In'   },
  { to: '/register',  label: 'Register'   },
  { to: '/dashboard', label: 'Dashboard'  },
  { to: '/admin',     label: 'Admin'      },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const linkStyle = (active) => ({
    padding: '0 14px', height: '100%', display: 'flex', alignItems: 'center',
    fontSize: 13, fontWeight: 500, textDecoration: 'none',
    color: active ? '#2563eb' : '#6b7280',
    borderBottom: active ? '2px solid #2563eb' : '2px solid transparent',
  });
  const mobileLinkStyle = (active) => ({
    display: 'block', padding: '12px 16px', fontWeight: 500,
    color: active ? '#2563eb' : '#374151', textDecoration: 'none',
    background: active ? '#eff6ff' : 'transparent', borderRadius: 8,
  });

  return (
    <nav style={{ background: '#fff', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 100 }}>
      <div style={{ display: 'flex', alignItems: 'center', height: 56, padding: '0 1rem' }}>
        <span style={{ fontWeight: 700, fontSize: 15, marginRight: 'auto' }}>✅ Attendance</span>
        {/* Desktop links */}
        <div style={{ display: 'flex', height: '100%' }} className="hide-mobile">
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} style={({ isActive }) => linkStyle(isActive)}>
              {l.label}
            </NavLink>
          ))}
        </div>
        {/* Mobile hamburger */}
        <button onClick={() => setOpen(o => !o)} style={{ background: 'none', fontSize: 22, padding: 4, display: 'none' }} className="show-mobile">
          {open ? '✕' : '☰'}
        </button>
      </div>
      {/* Mobile menu */}
      {open && (
        <div style={{ padding: '8px 12px 12px', borderTop: '1px solid #e5e7eb' }}>
          {links.map(l => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} onClick={() => setOpen(false)}
              style={({ isActive }) => mobileLinkStyle(isActive)}>
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
      <style>{`.hide-mobile { display: flex !important; } .show-mobile { display: none !important; } @media(max-width:640px){.hide-mobile{display:none!important}.show-mobile{display:block!important}}`}</style>
    </nav>
  );
}
